<template>
  <div class="personal-info">
    <div class="title-container">
      <span> اطلاعات بانکی </span>
      <!-- <div class="addcard">
                <img class="addcard-img" src="../../../assets/icons/addcard.svg" alt="">
                <span class="addcardbtn"> اضافه کردن کارت </span>
            </div> -->
    </div>
    <div class="card-container">
      <AccountField
        v-model="newCard.cardNumber"
        label="شماره کارت"
        type="dash"
        ltr
        :maxLength="19"
      />
      <AccountField
        v-model="newCard.shebaCode"
        label="شماره شبا"
        type="number"
        ltr
        :maxLength="24"
      />
      <button :disabled="disable" @click="addCard" class="submit addtocardsbtn">
        {{ disable ? disable : "افزودن کارت بانکی" }}
      </button>
    </div>

    <template v-for="(card, index) in data.bankAccounts">
      <div
        v-if="card.shebaCode && card.cardNumber"
        :key="index"
        class="card-container"
      >
        <AccountField
          v-model="card.cardNumber"
          label="شماره کارت"
          ltr
          disabled
        />
        <AccountField v-model="card.shebaCode" label="شماره شبا" ltr disabled />
        <div
          v-if="data.bankAccounts.length > 1"
          @click="deleteCart(card)"
          class="delet"
        >
          <inline-svg
            :src="require('../../../assets/icons/remove.svg')"
            alt=""
          />
          <span> حذف </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AccountField from "./AccountField.vue";

export default {
  components: { AccountField },
  props: ["data"],
  data() {
    return {
      newCard: {
        shebaCode: "",
        cardNumber: "",
      },
      // cards:[...this.data.bankAccounts,...this.state.userInfo.bankAccounts],
    };
  },
  computed: {
    // cards(){
    //     let allCards
    //         allCards = [...this.data.bankAccounts,...this.state.userInfo.bankAccounts]
    //     return allCards
    // },
    disable() {
      let err;
      if (!this.newCard.cardNumber) {
        err = "شماره کارت را وارد کنید";
      } else if (this.newCard.cardNumber.length !== 19) {
        err = "شماره کارت صحیح وارد کنید";
      } else if (!this.newCard.shebaCode) {
        err = "شماره شبا را وارد کنید";
      } else if (this.newCard.shebaCode.length != 24) {
        err = "شماره شبا صحیح وارد کنید";
      } else {
        err = false;
      }
      return err;
    },
  },
  methods: {
    deleteCart(item) {
      let indx = this.data.bankAccounts.indexOf(item);
      this.data.bankAccounts.splice(indx, 1);
    },
    dash() {
      if (this.newCard.cardNumber) {
        this.newCard.cardNumber = this.$separator(this.newCard.cardNumber);
        let lngth = this.newCard.cardNumber.replace(/-/gi, "").length;
        if (lngth >= 16) {
          this.newCard.cardNumber = this.newCard.cardNumber
            .replace(/-/gi, "")
            .slice(0, 16);
          this.newCard.cardNumber = this.$separator(this.newCard.cardNumber);
        }
      }
    },
    addCard() {
      this.data.bankAccounts = [
        {
          shebaCode: this.newCard.shebaCode,
          // cardNumber: this.newCard.cardNumber.replace(/-/gi, ""),
          cardNumber: this.newCard.cardNumber,
        },
        ...this.data.bankAccounts,
      ];
      this.newCard = {
        shebaCode: "",
        cardNumber: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.delet {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  column-gap: 4px;
  align-items: center;
  span {
    color: var(--red);
    font-size: clamp(14px, 1vw, 12px);
  }
  svg {
    fill: var(--red);
    width: 18px;
    height: 18px;
  }
}
.addtocardsbtn {
  width: 40%;
  min-width: 130px;
}
.addcard-img {
  width: 12px;
  height: 12px;
}
.addcardbtn {
  color: var(--primary-color);
  font-size: clamp(12px, 1vw, 14px);
}
.addcard {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
}
.card-container {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 12px;
}
.ac-input {
  border-radius: 4px;
  // overflow: hidden;
  .bd {
    input {
      width: 100%;
    }
  }
  display: flex;
  flex-direction: column;
  row-gap: 3px;
  width: 100%;
  .active-span {
    color: var(--primary-color);
    transform: translateY(-25px);
  }
  label {
    display: flex;
    flex-direction: row;
    background: var(--light-grey);
    padding: 8px 12px;
    border-radius: 4px;
    position: relative;
    input {
      background: transparent;
      width: 80%;
      z-index: 2;
    }
    span {
      transform: translateY(0px);
      font-weight: 400;
      font-size: clamp(12px, 2vw, 14px);
      transition: 500ms;
      position: absolute;
    }
  }
}
span {
  font-weight: 400;
  font-size: clamp(14px, 2vw, 18px);
}
.personal-info {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 24px;
  background: var(--box);
  border-radius: 12px;
  width: 100%;
  input {
    width: 100% !important;
  }
}
.title-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media only screen and (max-width: 500px) {
  .submit {
    width: 100%;
  }
}
</style>
